// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_kz-0";
export var buttonContainer = "_kz-3";
export var cancelButton = "_kz-4";
export var headerSection = "_kz-6";
export var headerTitle = "_kz-9";
export var messageSideLeft = "_kz-1";
export var messageSideRight = "_kz-2";
export var orderNumberContainer = "_kz-7";
export var orderNumberLabel = "_kz-8";
export var submitButton = "_kz-5";